import { RadioGroup, XStack, View, Text, styled, GetProps } from "tamagui";
import Statement from "@components/statement/Statement";
import { colors } from "@styles/colors";

const RadioFrame = styled(XStack, {
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  backgroundColor: colors.light,
  height: 44,
  minWidth: 44,
  paddingHorizontal: 20,

  borderWidth: 1.5,
  borderColor: colors.bg,
  borderRadius: 10,
  animation: "quick",

  variants: {
    active: {
      true: {
        backgroundColor: colors.primaryActive,
        borderColor: colors.primary,
      },
    },
    disabled: {
      true: {
        opacity: 0.5,
      },
    },
    /** 膠囊外觀（瓦斯訂購 Skin V2）：矮一階、全圓角，未選是灰底無框、選中才是淡藍底藍框。 */
    pill: {
      true: {
        height: 38,
        minWidth: 38,
        paddingHorizontal: 16,
        borderRadius: 999,
        backgroundColor: "#F3F5F9",
        borderColor: "transparent",
      },
    },
  } as const,
});

type RadioGroupItemProps = {
  data: {
    id: string;
    options?: { label: string; value: string | boolean | number; statement?: { need: boolean; title?: string } }[];
  };
  value: any;
  disabled?: boolean;
  hasError?: boolean;
  /** 膠囊外觀（瓦斯訂購 Skin V2 用），預設 false = 原本的圓角矩形。 */
  pill?: boolean;
  onChange: (value: any) => void;
};

const RadioGroupBlock = ({ data, value, disabled, hasError, pill = false, onChange }: RadioGroupItemProps) => {
  return (
    <RadioGroup id={data.id} value={value?.toString()} onValueChange={onChange} disabled={disabled}>
      <XStack alignSelf="flex-start" flexWrap="wrap" gap={pill ? 8 : 10}>
        {data.options?.map((option) => {
          const isActive = value === option.value;
          return (
            <RadioFrame
              key={option.value.toString()}
              pill={pill}
              active={isActive}
              disabled={disabled}
              borderColor={hasError && !isActive ? "$red10" : undefined}
              onPress={() => {
                if (!disabled) {
                  onChange(option.value);
                }
              }}>
              <XStack alignItems="center" pointerEvents="none">
                <Text fontSize={pill ? 14 : 16} fontWeight={isActive ? "bold" : "500"} color={isActive ? colors.primary : pill ? "#5F6C7B" : colors.text}>
                  {option.label}
                </Text>
                {option.statement?.need && (
                  <View ml="$1">
                    <Statement title={option.statement?.title || ""} />
                  </View>
                )}
              </XStack>
            </RadioFrame>
          );
        })}
      </XStack>
    </RadioGroup>
  );
};

export default RadioGroupBlock;
